import React from 'react'
import { Box, Container, Grid, Typography, Button, Icon } from '@mui/material'
import noImg from "assets/images/notFound.png"
import { Link, useNavigate } from 'react-router-dom'

const NotFound = ({dashboard}) => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <Container>
        <Grid container display="flex" alignItems="center">
            <Grid item  xs={3} lg={5}>
                <Box component="img" src={noImg} sx={{width:"100%"}} />
            </Grid>
            <Grid item xs={9} lg={7} p={{xs:1, lg :4}} >
                <Typography variant="h1" color="warnning" sx={{fontSize : {xs:20,md:30, lg:40}}}>Page Not Found</Typography>
                <Typography variant="h4" sx={{fontSize : {xs:14,md:24, lg:30}}}  color="secondary" >Ops !, il semble qu'aucune page ne corresponde à cette adresse</Typography>
                <Button sx={{mt:1, color:({ palette : {text} }) => text.main }} color="primary" variant="outlined" onClick={handleGoBack}><Icon fontSize='medium' sx={{ mr:1}}>replay_all</Icon> Retournez à la page d'accueil</Button>
            </Grid>
        </Grid>
    </Container>
  )
}

export default NotFound